import { contentStyle } from "../fuctions";

const titleStyle=contentStyle`
font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 60px;
line-height: 73px;
/* identical to box height */


color: #000000;
`;

const FeedbackSectionTitle = () => {
    return <p style={titleStyle}>
        What our clients say on it
      </p>;
  };
  
  export default FeedbackSectionTitle;
  